import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../hooks/redux';
import { setContentMasterSubscriptionInsufficientModalVisible } from '../../store/slices/contentMasterSlice';

type ContentMasterProBadgeProps = {
  className?: string;
  title?: string;
  /** Opens the upgrade modal on click. Default: true. */
  interactive?: boolean;
  /** Badge text. Default: "Pro" (e.g. "Add-on" for add-on-gated features). */
  label?: string;
};

const ContentMasterProBadge: React.FC<ContentMasterProBadgeProps> = ({
  className = '',
  title,
  interactive = true,
  label = 'Pro',
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const tooltip = title ?? t('cm_entitlements_starter_wawi_disabled');

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!interactive) {
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    dispatch(setContentMasterSubscriptionInsufficientModalVisible(true));
  };

  if (!interactive) {
    return (
      <span
        className={`content-master-pro-badge${className ? ` ${className}` : ''}`}
        title={tooltip}
        aria-label={tooltip}
      >
        {label}
      </span>
    );
  }

  return (
    <button
      type="button"
      className={`content-master-pro-badge content-master-pro-badge--interactive${
        className ? ` ${className}` : ''
      }`}
      title={tooltip}
      aria-label={tooltip}
      onClick={handleClick}
    >
      {label}
    </button>
  );
};

export default ContentMasterProBadge;
